(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

(() => {

/* ======================================================
MOBILE MENU
====================================================== */

const initHeaderMenu =
header => {

if (
!header ||
header.dataset.mobileMenuReady === 'true'
) {
return;
}

const menuId =
header
.querySelector(
'[data-mobile-menu-open]'
)
?.getAttribute(
'aria-controls'
);

const menu =
menuId
? document.getElementById(
menuId
)
: null;

const panel =
menu
? menu.querySelector(
'[data-mobile-menu-panel]'
)
: null;

const openButtons =
Array.from(
header.querySelectorAll(
'[data-mobile-menu-open]'
)
);

const closeButtons =
menu
? Array.from(
menu.querySelectorAll(
'[data-mobile-menu-close]'
)
)
: [];

if (
!menu ||
!panel ||
openButtons.length ===
0
) {
return;
}

header.dataset.mobileMenuReady =
'true';

let lastTrigger =
null;

let closeTimer =
null;

const getFocusable =
() =>
Array.from(
panel.querySelectorAll(
'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
)
);

const setExpanded =
expanded => {

openButtons.forEach(
button => {

button.setAttribute(
'aria-expanded',
expanded
? 'true'
: 'false'
);

}
);

};

const openMenu =
trigger => {

if (closeTimer) {
window.clearTimeout(
closeTimer
);
}

lastTrigger =
trigger ||
null;

menu.hidden =
false;

document.body
.classList
.add(
'mobile-menu-open'
);

setExpanded(
true
);

window.requestAnimationFrame(
() => {

menu.classList.add(
'is-open'
);

const focusable =
getFocusable();

if (
focusable.length
) {
focusable[0]
.focus();
}

}
);

};

const closeMenu =
() => {

menu.classList.remove(
'is-open'
);

document.body
.classList
.remove(
'mobile-menu-open'
);

setExpanded(
false
);

closeTimer =
window.setTimeout(
() => {

menu.hidden =
true;

if (
lastTrigger &&
document.contains(
lastTrigger
)
) {
lastTrigger.focus();
}

},
240
);

};

openButtons.forEach(
button => {

button.addEventListener(
'click',
() =>
openMenu(
button
)
);

}
);

closeButtons.forEach(
button => {

button.addEventListener(
'click',
closeMenu
);

}
);

menu.addEventListener(
'keydown',
event => {

if (
event.key ===
'Escape'
) {

event.preventDefault();

closeMenu();

return;

}

if (
event.key !==
'Tab'
) {
return;
}

const focusable =
getFocusable();

if (
!focusable.length
) {
return;
}

const first =
focusable[0];

const last =
focusable[
focusable.length -
1
];

if (
event.shiftKey &&
document.activeElement ===
first
) {

event.preventDefault();

last.focus();

} else if (
!event.shiftKey &&
document.activeElement ===
last
) {

event.preventDefault();

first.focus();

}

}
);

window.addEventListener(
'resize',
() => {

if (
window.innerWidth >=
990 &&
!menu.hidden
) {

closeMenu();

}

}
);

};

const initAllHeaders =
(root = document) => {

root
.querySelectorAll(
'[data-header]'
)
.forEach(
header => {

const sectionWrapper =
header.closest(
'.shopify-section'
);

if (sectionWrapper) {

sectionWrapper
.classList
.add(
'laffan-sticky-header-section'
);

const syncMobileStickyHeaderHeight = () => {

if (window.innerWidth <= 749) {

sectionWrapper.style.setProperty(
'--laffan-mobile-header-height',
`${header.offsetHeight}px`
);

} else {

sectionWrapper.style.removeProperty(
'--laffan-mobile-header-height'
);

}

};

syncMobileStickyHeaderHeight();

if (header.dataset.stickyHeightReady !== 'true') {

header.dataset.stickyHeightReady = 'true';

window.addEventListener(
'resize',
syncMobileStickyHeaderHeight,
{ passive: true }
);

if ('ResizeObserver' in window) {

const stickyHeaderResizeObserver =
new ResizeObserver(
syncMobileStickyHeaderHeight
);

stickyHeaderResizeObserver.observe(
header
);

}

}

}

initHeaderMenu(
header
);

const backButton =
header.querySelector(
'[data-laffan-history-back]'
);

if (
backButton &&
backButton.dataset.historyBackReady !== 'true'
) {

backButton.dataset.historyBackReady =
'true';

backButton.addEventListener(
'click',
event => {

event.preventDefault();

if (
window.history.length > 1
) {

window.history.back();

} else {

window.location.href =
window.LaffanTheme?.root ||
'/';

}

}
);

}

}
);

};

initAllHeaders();

document.addEventListener(
'shopify:section:load',
event => {

initAllHeaders(
event.target
);

}
);

/* ======================================================
ACCOUNT DRAWER
====================================================== */

const accountWrapper =
document.querySelector(
'[data-account-wrapper]'
);

const accountOpenButtons =
Array.from(
document.querySelectorAll(
'[data-account-open]'
)
);

const accountCloseButtons =
Array.from(
document.querySelectorAll(
'[data-account-close]'
)
);

let accountCloseTimer =
null;

const openAccount =
trigger => {

if (
!accountWrapper
) {
return;
}

const mobileMenu =
document.querySelector(
'[data-mobile-menu]'
);

if (
mobileMenu &&
!mobileMenu.hidden
) {

mobileMenu.classList.remove(
'is-open'
);

document.body
.classList
.remove(
'mobile-menu-open'
);

window.setTimeout(
() => {

mobileMenu.hidden =
true;

},
220
);

}

if (
accountCloseTimer
) {

clearTimeout(
accountCloseTimer
);

}

accountWrapper.hidden =
false;

document.body
.classList
.add(
'account-drawer-open'
);

accountOpenButtons
.forEach(
button => {

button.setAttribute(
'aria-expanded',
'true'
);

}
);

window.requestAnimationFrame(
() => {

accountWrapper
.classList
.add(
'is-open'
);

}
);

};

const closeAccount =
() => {

if (
!accountWrapper
) {
return;
}

accountWrapper
.classList
.remove(
'is-open'
);

document.body
.classList
.remove(
'account-drawer-open'
);

accountOpenButtons
.forEach(
button => {

button.setAttribute(
'aria-expanded',
'false'
);

}
);

accountCloseTimer =
window.setTimeout(
() => {

accountWrapper.hidden =
true;

},
240
);

};

accountOpenButtons
.forEach(
button => {

button.addEventListener(
'click',
event => {

event.preventDefault();

openAccount(
button
);

}
);

}
);

accountCloseButtons
.forEach(
button => {

button.addEventListener(
'click',
closeAccount
);

}
);

document.addEventListener(
'keydown',
event => {

if (
event.key === 'Escape' &&
accountWrapper &&
!accountWrapper.hidden
) {

closeAccount();

}

}
);

/* ======================================================
INLINE ORDER DETAILS + BUY AGAIN
====================================================== */

document.addEventListener(
'click',
async event => {

const detailsButton =
event.target.closest(
'[data-order-details-toggle]'
);

if (detailsButton) {

const card =
detailsButton.closest(
'[data-account-order-card]'
);

const details =
card?.querySelector(
'[data-order-details]'
);

if (!details) {
return;
}

const willOpen =
details.hidden;

details.hidden =
!willOpen;

detailsButton.setAttribute(
'aria-expanded',
willOpen
? 'true'
: 'false'
);

const isArabic =
document.documentElement.dir ===
'rtl';

detailsButton.textContent =
willOpen
? (
isArabic
? 'إخفاء الطلب'
: 'Hide order'
)
: (
isArabic
? 'عرض الطلب'
: 'View order'
);

return;

}

const reorderButton =
event.target.closest(
'[data-order-reorder]'
);

if (!reorderButton) {
return;
}

event.preventDefault();

const card =
reorderButton.closest(
'[data-account-order-card]'
);

const message =
card?.querySelector(
'[data-order-message]'
);

const rawItems =
reorderButton.dataset.reorderItems ||
'';

if (!rawItems) {
return;
}

const items =
rawItems
.split(',')
.map(item => {

const parts =
item.split(':');

return {
id:
Number(parts[0]),
quantity:
Math.max(
1,
Number(parts[1]) || 1
)
};

})
.filter(
item =>
Number.isFinite(item.id) &&
item.id > 0
);

if (!items.length) {
return;
}

const isArabic =
document.documentElement.dir ===
'rtl';

const originalText =
reorderButton.textContent;

reorderButton.disabled =
true;

reorderButton.textContent =
isArabic
? 'جارٍ الإضافة...'
: 'Adding...';

if (message) {
message.hidden = true;
message.classList.remove('is-error');
}

try {

const root =
window.Shopify?.routes?.root ||
'/';

const response =
await fetch(
root + 'cart/add.js',
{
method: 'POST',
headers: {
'Content-Type':
'application/json',
'Accept':
'application/json'
},
body:
JSON.stringify({
items
})
}
);

const data =
await response.json();

if (!response.ok) {
throw new Error(
data?.description ||
data?.message ||
'Unable to add order'
);
}

if (message) {

message.textContent =
isArabic
? 'تمت إضافة الطلب إلى السلة.'
: 'Order added to cart.';

message.hidden =
false;

}

try {

const cartResponse =
await fetch(
root + 'cart.js',
{
headers: {
'Accept':
'application/json'
},
cache:
'no-store'
}
);

if (cartResponse.ok) {

const cart =
await cartResponse.json();

document
.querySelectorAll(
'[data-cart-count]'
)
.forEach(
counter => {
counter.textContent =
cart.item_count;
}
);

document.dispatchEvent(
new CustomEvent(
'cart:updated',
{
detail: {
cart
}
}
)
);

}

} catch (error) {

}

reorderButton.textContent =
isArabic
? 'جارٍ فتح السلة...'
: 'Opening cart...';

closeAccount();

window.setTimeout(
async () => {

try {

if (
window.Shopify?.actions?.openCart
) {

await window.Shopify.actions.openCart();

return;

}

} catch (error) {

console.error(
'Open cart action failed:',
error
);

}

const cartOpenButton =
document.querySelector(
'[data-cart-open]'
);

if (cartOpenButton) {

cartOpenButton.click();

return;

}

window.location.href =
root + 'cart';

},
180
);

} catch (error) {

console.error(
'Buy again error:',
error
);

if (message) {

message.textContent =
isArabic
? 'تعذر إضافة بعض المنتجات. قد يكون أحد المنتجات غير متوفر حالياً.'
: 'Some items could not be added. One or more products may be unavailable.';

message.classList.add(
'is-error'
);

message.hidden =
false;

}

reorderButton.textContent =
originalText;

reorderButton.disabled =
false;

}

}
);

/* ======================================================
SHOPIFY SECURE SIGN-IN SHEET
====================================================== */

const accountLoginComponents =
Array.from(
document.querySelectorAll(
'.account-login-box shopify-account'
)
);

accountLoginComponents
.forEach(
component => {

component.addEventListener(
'open',
() => {

try {

sessionStorage.setItem(
'laffanAccountLoginStarted',
'1'
);

} catch (error) {

}

}
);

component.addEventListener(
'close',
() => {

let loginStarted =
false;

try {

loginStarted =
sessionStorage.getItem(
'laffanAccountLoginStarted'
) ===
'1';

} catch (error) {

}

if (
!loginStarted
) {
return;
}

try {

sessionStorage.setItem(
'laffanReopenAccount',
'1'
);

sessionStorage.removeItem(
'laffanAccountLoginStarted'
);

} catch (error) {

}

window.location.reload();

}
);

}
);

/* ======================================================
REOPEN ACCOUNT AFTER LOGIN REFRESH
====================================================== */

let shouldReopenAccount =
false;

try {

shouldReopenAccount =
sessionStorage.getItem(
'laffanReopenAccount'
) ===
'1';

if (
shouldReopenAccount
) {

sessionStorage.removeItem(
'laffanReopenAccount'
);

}

} catch (error) {

}

if (
shouldReopenAccount &&
accountWrapper
) {

window.setTimeout(
() => {

openAccount(
null
);

},
80
);

}

/* ======================================================
GLOBAL SUPPORT FOR BOTTOM MOBILE ACCOUNT BUTTON
====================================================== */

document.addEventListener(
'click',
event => {

const accountLink =
event.target.closest(
'a[href*="/account"], a[href*="/customer_authentication"]'
);

if (
!accountLink
) {
return;
}

if (
accountLink.matches(
'[data-account-direct]'
)
) {
return;
}

if (
accountLink.matches(
'.account-drawer__logout'
) ||
accountLink.href.includes(
'/logout'
)
) {
return;
}

if (
accountLink.closest(
'shopify-account'
)
) {
return;
}

event.preventDefault();

event.stopPropagation();

openAccount(
accountLink
);

},
true
);

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    

(() => {

  const initHeroSlider = (slider) => {

    if (
      !slider ||
      slider.dataset.heroInitialized === 'true'
    ) return;

    const slides = Array.from(
      slider.querySelectorAll('[data-hero-slide]')
    );

    const dots = Array.from(
      slider.querySelectorAll('[data-hero-dot]')
    );

    const prev =
      slider.querySelector('[data-hero-prev]');

    const next =
      slider.querySelector('[data-hero-next]');

    if (!slides.length) return;

    slider.dataset.heroInitialized = 'true';

    let current = 0;
    let timer = null;
    let touchStartX = null;

    const autoplay =
      slider.dataset.autoplay === 'true';

    const speed =
      Math.max(
        3000,
        Number(slider.dataset.speed) || 5000
      );

    const reduceMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


    const updateSliderRatio = (slide) => {

      if (!slide) return;

      const desktopRatio =
        Number(slide.dataset.desktopRatio) || 2.2857;

      const mobileRatio =
        Number(slide.dataset.mobileRatio) || desktopRatio;

      slider.style.setProperty(
        '--hero-desktop-ratio',
        desktopRatio
      );

      slider.style.setProperty(
        '--hero-mobile-ratio',
        mobileRatio
      );

    };


    const showSlide = (index) => {

      current =
        (index + slides.length) % slides.length;

      slides.forEach((slide,i) => {

        const active = i === current;

        slide.classList.toggle(
          'is-active',
          active
        );

      });

      dots.forEach((dot,i) => {

        dot.classList.toggle(
          'is-active',
          i === current
        );

      });

      updateSliderRatio(slides[current]);

    };


    const stop = () => {

      if (timer) {
        window.clearInterval(timer);
      }

      timer = null;

    };


    const start = () => {

      stop();

      if (
        autoplay &&
        !reduceMotion &&
        slides.length > 1
      ) {

        timer =
          window.setInterval(
            () => showSlide(current + 1),
            speed
          );

      }

    };


    if (prev) {

      prev.addEventListener(
        'click',
        () => {

          showSlide(current - 1);
          start();

        }
      );

    }


    if (next) {

      next.addEventListener(
        'click',
        () => {

          showSlide(current + 1);
          start();

        }
      );

    }


    dots.forEach((dot) => {

      dot.addEventListener(
        'click',
        () => {

          showSlide(
            Number(dot.dataset.index) || 0
          );

          start();

        }
      );

    });


    /* MOBILE SWIPE */

    slider.addEventListener(
      'touchstart',
      (event) => {

        touchStartX =
          event.changedTouches[0].clientX;

        stop();

      },
      { passive: true }
    );


    slider.addEventListener(
      'touchend',
      (event) => {

        if (touchStartX === null) return;

        const distance =
          event.changedTouches[0].clientX -
          touchStartX;

        if (Math.abs(distance) > 45) {

          showSlide(
            current +
            (distance < 0 ? 1 : -1)
          );

        }

        touchStartX = null;

        start();

      },
      { passive: true }
    );


    slider.addEventListener(
      'mouseenter',
      stop
    );

    slider.addEventListener(
      'mouseleave',
      start
    );


    showSlide(0);
    start();

  };


  const initAll = (root = document) => {

    root
      .querySelectorAll('[data-hero-slider]')
      .forEach(initHeroSlider);

  };


  initAll();


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initAll(event.target);

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laffan-account-page"]) return;
  try {
    



(() => {



  const page =

    document.querySelector(

      '[data-laffan-account-page]'

    );



  if (

    !page ||

    page.dataset.ready === 'true'

  ) {

    return;

  }



  page.dataset.ready =

    'true';





  const isArabic =

    () =>

      document.documentElement.dir ===

      'rtl';





  /* ======================================================

     SHOPIFY SIGN IN

  ====================================================== */



  page

    .querySelectorAll(

      '[data-account-guest-login] shopify-account'

    )

    .forEach(

      component => {



        component.addEventListener(

          'open',

          () => {



            try {



              sessionStorage.setItem(

                'laffanMyAccountLoginStarted',

                '1'

              );



            } catch (error) {

            }



          }

        );





        component.addEventListener(

          'close',

          () => {



            let started =

              false;





            try {



              started =

                sessionStorage.getItem(

                  'laffanMyAccountLoginStarted'

                ) === '1';



            } catch (error) {

            }





            if (

              !started

            ) {

              return;

            }





            try {



              sessionStorage.removeItem(

                'laffanMyAccountLoginStarted'

              );



            } catch (error) {

            }





            window.location.reload();



          }

        );



      }

    );





  /* ======================================================

     ADDRESS EDITOR

  ====================================================== */



  const addressEditor =

    page.querySelector(

      '[data-address-editor]'

    );





  const addressEditButton =

    page.querySelector(

      '[data-address-edit-toggle]'

    );





  const addressCancelButton =

    page.querySelector(

      '[data-address-edit-cancel]'

    );





  const addressForm =

    page.querySelector(

      '.laffan-account-address-form'

    );





  const addressFormMessage =

    page.querySelector(

      '[data-address-form-message]'

    );





  const defaultAddressSummary =

    page.querySelector(

      '[data-default-address-summary]'

    );





  const setAddressEditorOpen =

    open => {



      if (

        !addressEditor

      ) {

        return;

      }





      addressEditor.hidden =

        !open;





      addressEditButton?.setAttribute(

        'aria-expanded',

        open

          ? 'true'

          : 'false'

      );



    };





  addressEditButton

    ?.addEventListener(

      'click',

      () => {



        setAddressEditorOpen(

          addressEditor?.hidden !== false

        );



      }

    );





  addressCancelButton

    ?.addEventListener(

      'click',

      () => {



        setAddressEditorOpen(

          false

        );



      }

    );





  try {



    const params =

      new URLSearchParams(

        window.location.search

      );





    if (

      params.get(

        'edit_address'

      ) === '1'

    ) {



      setAddressEditorOpen(

        true

      );



    }



  } catch (error) {

  }





  addressForm

    ?.addEventListener(

      'submit',

      async event => {



        event.preventDefault();





        const saveScrollY =

          window.scrollY ||

          window.pageYOffset ||

          0;





        const restorePosition =

          () => {



            window.scrollTo({

              top:

                saveScrollY,

              left:

                0,

              behavior:

                'auto'

            });



          };





        const saveButton =

          addressForm.querySelector(

            '[data-address-save]'

          );





        const originalText =

          saveButton?.textContent ||

          '';





        const address1 =

          addressForm.querySelector(

            '[name="address[address1]"]'

          );





        const address2 =

          addressForm.querySelector(

            '[name="address[address2]"]'

          );





        const city =

          addressForm.querySelector(

            '[name="address[city]"]'

          );





        const country =

          addressForm.querySelector(

            '[name="address[country]"]'

          );





        if (

          addressFormMessage

        ) {



          addressFormMessage.hidden =

            true;



          addressFormMessage.textContent =

            '';



        }





        if (

          saveButton

        ) {



          saveButton.disabled =

            true;



          saveButton.textContent =

            isArabic()

              ? 'جارٍ الحفظ...'

              : 'Saving...';



        }





        try {



          const response =

            await fetch(

              addressForm.action,

              {

                method:

                  addressForm.method ||

                  'POST',



                body:

                  new FormData(

                    addressForm

                  ),



                credentials:

                  'same-origin',



                redirect:

                  'manual'

              }

            );





          const ok =

            response.ok ||

            response.type ===

              'opaqueredirect' ||

            response.status ===

              0;





          if (

            !ok

          ) {



            throw new Error(

              `Address update failed: ${response.status}`

            );



          }





          const parts =

            [

              address1?.value?.trim(),

              address2?.value?.trim(),

              city?.value?.trim()

            ]

              .filter(

                Boolean

              );





          if (

            defaultAddressSummary

          ) {



            defaultAddressSummary.textContent =

              parts.join(

                ' · '

              ) ||

              country?.value?.trim() ||

              (

                isArabic()

                  ? 'قطر'

                  : 'Qatar'

              );



          }





          if (

            saveButton

          ) {



            saveButton.textContent =

              isArabic()

                ? 'تم الحفظ'

                : 'Saved';



          }





          restorePosition();





          requestAnimationFrame(

            restorePosition

          );





          setTimeout(

            restorePosition,

            80

          );





          setTimeout(

            restorePosition,

            260

          );





          setTimeout(

            () => {



              if (

                !saveButton

              ) {

                return;

              }





              saveButton.disabled =

                false;





              saveButton.textContent =

                originalText;



            },

            650

          );





        } catch (error) {





          console.error(

            'Laffan address update error:',

            error

          );





          if (

            addressFormMessage

          ) {



            addressFormMessage.textContent =

              isArabic()

                ? 'تعذر حفظ العنوان. حاول مرة أخرى.'

                : 'Unable to save the address. Please try again.';





            addressFormMessage.hidden =

              false;



          }





          if (

            saveButton

          ) {



            saveButton.disabled =

              false;





            saveButton.textContent =

              originalText;



          }



        }



      }

    );





  /* ======================================================

     VIEW ORDER

  ====================================================== */



  page

    .querySelectorAll(

      '[data-order-details-toggle]'

    )

    .forEach(

      button => {



        button.addEventListener(

          'click',

          event => {



            event.preventDefault();



            event.stopPropagation();





            const card =

              button.closest(

                '[data-account-order-card]'

              );





            const details =

              card?.querySelector(

                '[data-order-details]'

              );





            if (

              !details

            ) {

              return;

            }





            const opening =

              details.hasAttribute(

                'hidden'

              );





            if (

              opening

            ) {



              details.removeAttribute(

                'hidden'

              );



            } else {



              details.setAttribute(

                'hidden',

                ''

              );



            }





            button.setAttribute(

              'aria-expanded',

              opening

                ? 'true'

                : 'false'

            );





            button.textContent =

              opening

                ? (

                    isArabic()

                      ? 'إخفاء الطلب'

                      : 'Hide order'

                  )

                : (

                    isArabic()

                      ? 'عرض الطلب'

                      : 'View order'

                  );



          }

        );



      }

    );





  /* ======================================================

     BUY AGAIN

     - DO NOT OPEN CART DRAWER

     - ONE BULK CART ADD REQUEST

     - NO PARALLEL REQUESTS

     - NO FALSE 429 ERROR AFTER SUCCESS

     - AUTOMATIC BACKGROUND CART REFRESH

     - KEEP CURRENT LANGUAGE

  ====================================================== */



  const getLocalizedRoot =

    () => {



      let root =

        window.Shopify

          ?.routes

          ?.root ||

        '/';





      if (

        !root.endsWith('/')

      ) {



        root += '/';



      }





      const path =

        window.location.pathname ||

        '';





      if (

        /^\/ar(?:\/|$)/i.test(

          path

        ) &&

        !/^\/ar(?:\/|$)/i.test(

          root

        )

      ) {



        root =

          '/ar/';



      }





      return root;



    };





  const getCartFetch =

    () => {



      if (

        typeof window.__laffanNativeFetch ===

        'function'

      ) {



        return window.__laffanNativeFetch;



      }





      return window.fetch.bind(

        window

      );



    };





  const normalizeReorderItems =

    raw => {



      const merged =

        new Map();





      String(

        raw ||

        ''

      )

        .split(',')

        .forEach(

          value => {



            const [

              rawId,

              rawQuantity

            ] =

              value.split(':');





            const id =

              Number(

                rawId

              );





            const quantity =

              Math.max(

                1,

                Number(

                  rawQuantity

                ) || 1

              );





            if (

              !Number.isFinite(id) ||

              id <= 0

            ) {

              return;

            }





            merged.set(

              id,

              (

                merged.get(id) ||

                0

              ) +

              quantity

            );



          }

        );





      return Array

        .from(

          merged.entries()

        )

        .map(

          ([

            id,

            quantity

          ]) => ({

            id,

            quantity

          })

        );



    };





  const updateCartCountOptimistically =

    items => {



      const quantityToAdd =

        items.reduce(

          (

            total,

            item

          ) =>

            total +

            Number(

              item.quantity ||

              0

            ),

          0

        );





      if (

        quantityToAdd <= 0

      ) {

        return;

      }





      document

        .querySelectorAll(

          '[data-cart-count]'

        )

        .forEach(

          counter => {



            const current =

              Number(

                counter.textContent ||

                0

              );





            counter.textContent =

              String(

                Math.max(

                  0,

                  current +

                  quantityToAdd

                )

              );



          }

        );





      document

        .querySelectorAll(

          '[data-floating-cart-count]'

        )

        .forEach(

          counter => {



            const current =

              Number(

                counter.textContent ||

                0

              );





            const next =

              Math.max(

                0,

                current +

                quantityToAdd

              );





            counter.textContent =

              String(

                next

              );





            counter.classList.toggle(

              'is-empty',

              next <= 0

            );



          }

        );



    };





  const refreshCartInBackground =

    async root => {



      const cartFetch =

        getCartFetch();





      try {



        const response =

          await cartFetch(

            root +

            'cart.js',

            {

              method:

                'GET',



              headers: {

                'Accept':

                  'application/json'

              },



              credentials:

                'same-origin',



              cache:

                'no-store'

            }

          );





        if (

          !response.ok

        ) {

          return null;

        }





        const cart =

          await response.json();





        document

          .querySelectorAll(

            '[data-cart-count]'

          )

          .forEach(

            counter => {



              counter.textContent =

                cart.item_count;



            }

          );





        document

          .querySelectorAll(

            '[data-floating-cart-count]'

          )

          .forEach(

            counter => {



              counter.textContent =

                cart.item_count;





              counter.classList.toggle(

                'is-empty',

                cart.item_count <= 0

              );



            }

          );





        document.dispatchEvent(

          new CustomEvent(

            'cart:updated',

            {

              detail: {

                cart

              }

            }

          )

        );





        return cart;



      } catch (error) {



        console.warn(

          'Laffan background cart refresh skipped:',

          error

        );





        return null;



      }



    };





  const readResponseJson =

    async response => {



      try {



        return await response.json();



      } catch (error) {



        return null;



      }



    };





  const postCartItems = async (
    root,
    items
  ) => {
    const cartFetch = getCartFetch();

    const response = await cartFetch(
      root + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type':
            'application/json',
          'Accept':
            'application/json'
        },
        credentials: 'same-origin',
        cache: 'no-store',
        body: JSON.stringify({
          items
        })
      }
    );

    const contentType =
      response.headers.get(
        'content-type'
      ) || '';

    const data =
      contentType.includes(
        'application/json'
      )
        ? await readResponseJson(
            response
          )
        : null;

    return {
      response,
      data
    };
  };


  const readRealCart = async root => {
    const cartFetch = getCartFetch();

    const response = await cartFetch(
      root + 'cart.js',
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        `Cart read failed (${response.status})`
      );
    }

    return await response.json();
  };


  const getVariantCartQuantity = (
    cart,
    variantId
  ) => {
    return (
      Array.isArray(cart?.items)
        ? cart.items
        : []
    ).reduce(
      (total, item) => {
        if (
          Number(item?.variant_id) !==
          Number(variantId)
        ) {
          return total;
        }

        return (
          total +
          Number(item?.quantity || 0)
        );
      },
      0
    );
  };


  const addOrderItems = async (
    root,
    items
  ) => {
    /*
      FAST + SAFE FLOW

      1. Read cart once before.
      2. Try the complete order in one bulk request.
      3. Read cart once after bulk.
      4. Retry only missing products, sequentially.
      5. Read cart once at the end.

      This removes the slow cart read after every fallback item.
    */

    const beforeCart =
      await readRealCart(root);

    const beforeByVariant =
      new Map();

    for (const item of items) {
      beforeByVariant.set(
        Number(item.id),
        getVariantCartQuantity(
          beforeCart,
          item.id
        )
      );
    }

    let bulkAttempt =
      await postCartItems(
        root,
        items
      );

    if (
      bulkAttempt.response.status ===
      429
    ) {
      await new Promise(
        resolve =>
          setTimeout(
            resolve,
            350
          )
      );

      bulkAttempt =
        await postCartItems(
          root,
          items
        );
    }

    const afterBulkCart =
      await readRealCart(root);

    const missingItems = [];

    for (const item of items) {
      const id =
        Number(item.id);

      const requested =
        Math.max(
          1,
          Number(
            item.quantity || 1
          )
        );

      const before =
        Number(
          beforeByVariant.get(id) || 0
        );

      const afterBulk =
        getVariantCartQuantity(
          afterBulkCart,
          id
        );

      const addedByBulk =
        Math.max(
          0,
          afterBulk - before
        );

      const missing =
        Math.max(
          0,
          requested -
          addedByBulk
        );

      if (missing > 0) {
        missingItems.push({
          id,
          quantity: missing
        });
      }
    }

    /*
      Most reorders finish here. Only items that are really
      missing from the cart enter this fallback.
    */

    for (const item of missingItems) {
      let attempt =
        await postCartItems(
          root,
          [item]
        );

      if (
        attempt.response.status ===
        429
      ) {
        await new Promise(
          resolve =>
            setTimeout(
              resolve,
              350
            )
        );

        attempt =
          await postCartItems(
            root,
            [item]
          );
      }

      /*
        404 / 422 can happen for old variants or stock limits.
        Continue to the next product. The final cart read below
        determines what was actually added.
      */

      if (
        !attempt.response.ok &&
        ![
          400,
          404,
          422,
          429
        ].includes(
          attempt.response.status
        )
      ) {
        const error =
          new Error(
            attempt.data?.description ||
            attempt.data?.message ||
            `Cart add failed (${attempt.response.status})`
          );

        error.status =
          attempt.response.status;

        throw error;
      }
    }

    const finalCart =
      missingItems.length > 0
        ? await readRealCart(root)
        : afterBulkCart;

    const addedItems = [];
    const skippedItems = [];

    for (const item of items) {
      const id =
        Number(item.id);

      const requested =
        Math.max(
          1,
          Number(
            item.quantity || 1
          )
        );

      const before =
        Number(
          beforeByVariant.get(id) || 0
        );

      const finalQuantity =
        getVariantCartQuantity(
          finalCart,
          id
        );

      const actuallyAdded =
        Math.min(
          requested,
          Math.max(
            0,
            finalQuantity -
            before
          )
        );

      if (actuallyAdded > 0) {
        addedItems.push({
          id,
          quantity:
            actuallyAdded
        });
      }

      if (
        actuallyAdded <
        requested
      ) {
        skippedItems.push({
          id,
          quantity:
            requested -
            actuallyAdded
        });
      }
    }

    return {
      ok:
        addedItems.length > 0,
      uncertain:
        false,
      partial:
        skippedItems.length > 0,
      usedFallback:
        missingItems.length > 0,
      addedItems,
      skippedItems,
      cart:
        finalCart,
      data:
        bulkAttempt.data || null
    };
  };


  page.addEventListener(

    'click',

    async event => {



      const button =

        event.target.closest(

          '[data-order-reorder]'

        );





      if (

        !button

      ) {

        return;

      }





      event.preventDefault();



      event.stopPropagation();





      if (

        button.dataset.reorderBusy ===

        'true'

      ) {

        return;

      }





      const items =

        normalizeReorderItems(

          button.dataset.reorderItems ||

          ''

        );





      if (

        !items.length

      ) {

        return;

      }





      const card =

        button.closest(

          '[data-account-order-card]'

        );





      const message =

        card?.querySelector(

          '[data-order-message]'

        );





      const originalText =

        button.textContent;





      const preSkipped =

        button.dataset.reorderPreSkipped ===

        'true';





      button.dataset.reorderBusy =

        'true';





      button.disabled =

        true;





      button.textContent =

        isArabic()

          ? 'جارٍ الإضافة...'

          : 'Adding...';





      if (

        message

      ) {



        message.hidden =

          true;





        message.classList.remove(

          'is-error'

        );



      }





      try {



        const root =

          getLocalizedRoot();





        const result =

          await addOrderItems(

            root,

            items

          );





        const confirmedAddedItems =
          Array.isArray(result.addedItems)
            ? result.addedItems
            : [];

        // Only increase the visible cart count for items that
        // Shopify actually confirmed as added.
        if (confirmedAddedItems.length > 0) {
          updateCartCountOptimistically(
            confirmedAddedItems
          );
        }

        /*
          The helper already verified the result against the
          real Shopify cart. Refresh the visible cart UI now.
        */
        await refreshCartInBackground(root);

        const hadSkipped =
          preSkipped || result.partial;

        const addedSomething =
          confirmedAddedItems.length > 0;

        if (addedSomething) {
          button.textContent =
            isArabic()
              ? 'تمت الإضافة'
              : 'Added';

          if (message) {
            message.textContent =
              hadSkipped
                ? (
                    isArabic()
                      ? 'تمت إضافة المنتجات المتوفرة فعلياً إلى السلة، وتم تخطي المنتجات غير المتوفرة.'
                      : 'Available items were added to the cart. Unavailable items were skipped.'
                  )
                : (
                    isArabic()
                      ? 'تمت إضافة المنتجات إلى السلة.'
                      : 'Items added to cart.'
                  );

            message.hidden = false;
          }

        } else if (result.uncertain) {
          button.textContent = originalText;

          if (message) {
            message.textContent =
              isArabic()
                ? 'تم تحديث السلة. يرجى مراجعتها للتأكد من المنتجات التي تمت إضافتها.'
                : 'The cart was refreshed. Please check which items were added.';

            message.hidden = false;
          }

        } else {
          button.textContent = originalText;

          if (message) {
            message.textContent =
              isArabic()
                ? 'لم تتم إضافة أي منتج لأن المنتجات غير متوفرة حالياً.'
                : 'No items were added because the products are currently unavailable.';

            message.classList.add(
              'is-error'
            );

            message.hidden = false;
          }
        }


      } catch (error) {



        console.error(

          'Laffan account Buy again error:',

          error

        );





        if (

          message

        ) {



          message.textContent =

            isArabic()

              ? 'تعذر إضافة الطلب إلى السلة. حاول مرة أخرى.'

              : 'Unable to add this order to the cart. Please try again.';





          message.classList.add(

            'is-error'

          );





          message.hidden =

            false;



        }





        await refreshCartInBackground(

          getLocalizedRoot()

        );





      } finally {



        button.disabled =

          false;





        button.dataset.reorderBusy =

          'false';





        button.textContent =

          originalText;



      }



    }

  );



})();




  } catch(e) { console.error(e); }
})();
})();
